import React from "react";
import { Index } from "../components/FooterTexts/DataProcess/Index";

export const DataProcess = () => {
  return <Index />;
};
